import { AfterViewInit, ChangeDetectionStrategy, Component, HostBinding, OnDestroy } from '@angular/core';
import {
  CmsBannerCarouselComponent as model,
  CmsService,
  ContentSlotComponentData,
} from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import {
  CustomCmsEventService
} from "src/app/spartacus/features/tracking/custom-events/checkout/cms/custom-cms-event.service";


@Component({
  selector: 'cx-banner-carousel',
  templateUrl: 'custom-banner-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomBannerCarouselComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') theme = '';
  animation = 'swipe';
  timeout: any;
  protected subscriptions: Subscription = new Subscription();

  private componentData$: Observable<model> = this.componentData.data$.pipe(
    filter(Boolean),
    tap((d: model) => {
      this.theme = `${d.effect}-theme`;
      this.timeout = d.timeout;
    }),
  );

  items$: Observable<Observable<ContentSlotComponentData>[]> = this.componentData$.pipe(
    map((data) => data?.responsiveBanners?.trim()?.split(' ')),
    map((codes) => codes?.map((code) => this.cmsService.getComponentData(code))),
  );

  constructor(
    private componentData: CmsComponentData<model>,
    private cmsService: CmsService,
    protected customCmsEventService: CustomCmsEventService
  ) {
  }

  getItems(): Observable<Observable<ContentSlotComponentData>[]> {
    return this.items$;
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.items$.pipe(take(1)).subscribe(items => {
        const bannerList = this.customCmsEventService.getComponentList(items);
        this.customCmsEventService.dispatchViewPromotionEvent(bannerList);
      })
    )
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
